__turbopack_context__.v({
  "adornmentRow": "lDgkzq_adornmentRow",
  "visuallyHiddenDate": "lDgkzq_visuallyHiddenDate",
});
